import PropTypes from 'prop-types';
// layouts
import AuthPortalLayout from '../layouts/auth/AuthPortalLayout';
// the sign-in callback this load is taking in, if any
import { AUTH_CALLBACK_AT_LOAD } from '../contexts/JWTContext';

// ----------------------------------------------------------------------
// What a guard shows while the session is still being resolved: the portal's
// own sky with one line in the card's place (`AuthPortalLayout`'s `pending`),
// and never the sign-in form — rendering the form while the answer was merely
// UNKNOWN is what flashed it after Microsoft (2026-10-11).
//
// The session is only ever unresolved at load (JWTContext), so the load says
// which wait this is: a return from Microsoft or an email link is one the
// person expects and is named as a sign-in; anything else is a stored session
// being checked.
// ----------------------------------------------------------------------

export const SESSION_PENDING_LABEL = AUTH_CALLBACK_AT_LOAD
  ? 'Signing you in…'
  : 'Checking your session…';

SessionPending.propTypes = {
  portal: PropTypes.object.isRequired,
  label: PropTypes.string
};

export default function SessionPending({
  portal,
  label = SESSION_PENDING_LABEL
}) {
  return <AuthPortalLayout portal={portal} pending={label} />;
}
